import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronLeft, FaChevronRight, FaArrowRight, FaSpinner } from 'react-icons/fa';
import QRCodeSurvey from './QRCodeSurvey';
import { sliderPublicService } from '../../services/sliderPublicService';

const Slider = () => {
    const [sliderData, setSliderData] = useState([]);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadSliders();
    }, []);

    const loadSliders = async () => {
        setLoading(true);
        const result = await sliderPublicService.getSliders();
        if (result.success) {
            setSliderData(result.data.data || []);
        }
        setLoading(false);
    };

    useEffect(() => {
        if (sliderData.length === 0) return;

        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % sliderData.length);
        }, 5000);

        return () => clearInterval(timer);
    }, [sliderData]);

    const nextSlide = () => {
        if (sliderData.length > 0) {
            setCurrentSlide((prev) => (prev + 1) % sliderData.length);
        }
    };

    const prevSlide = () => {
        if (sliderData.length > 0) {
            setCurrentSlide((prev) => (prev - 1 + sliderData.length) % sliderData.length);
        }
    };

    // Loading state
    if (loading) {
        return (
            <div className="relative w-full bg-gradient-to-r from-[#0F4C3A] to-[#2E7D32] flex items-center justify-center"
                style={{ height: '500px' }}>
                <FaSpinner className="animate-spin text-4xl text-white" />
            </div>
        );
    }

    if (sliderData.length === 0) return null;

    return (
        <div className="relative w-full" style={{ maxHeight: '600px' }}>
            <div className="relative overflow-hidden" style={{ maxHeight: '600px' }}>
                {sliderData.map((slide, index) => (
                    <div
                        key={slide.id}
                        className={`transition-opacity duration-700 ${index === currentSlide ? 'opacity-100' : 'opacity-0 absolute inset-0'
                            }`}
                    >
                        <img
                            src={slide.image}
                            alt={slide.title}
                            className="w-full object-cover"
                            style={{ maxHeight: '600px' }}
                        />
                        <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-transparent">
                            <div className="container mx-auto px-4 h-full flex items-center">
                                <div className="text-white max-w-2xl">
                                    <h2 className="text-3xl md:text-5xl font-bold mb-4">
                                        {slide.title}
                                    </h2>
                                    <p className="text-lg md:text-xl opacity-90">
                                        {slide.description}
                                    </p>
                                    <div className="mt-6 flex flex-wrap gap-4">
                                        {slide.link && (
                                            slide.link.startsWith('http') ? (
                                                <a
                                                    href={slide.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn-primary inline-flex items-center"
                                                >
                                                    {slide.link_text || 'Selengkapnya'}
                                                    <FaArrowRight className="ml-2" />
                                                </a>
                                            ) : (
                                                <Link to={slide.link} className="btn-primary inline-flex items-center">
                                                    {slide.link_text || 'Selengkapnya'}
                                                    <FaArrowRight className="ml-2" />
                                                </Link>
                                            )
                                        )}
                                        {slide.link_secondary && (
                                            slide.link_secondary.startsWith('http') ? (
                                                <a
                                                    href={slide.link_secondary}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="bg-white/20 hover:bg-white/30 text-white px-6 py-2 rounded-lg transition-all"
                                                >
                                                    {slide.link_secondary_text || 'Layanan Kami'}
                                                </a>
                                            ) : (
                                                <Link
                                                    to={slide.link_secondary}
                                                    className="bg-white/20 hover:bg-white/30 text-white px-6 py-2 rounded-lg transition-all"
                                                >
                                                    {slide.link_secondary_text || 'Layanan Kami'}
                                                </Link>
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* QR Code Survey */}
            <QRCodeSurvey />

            {/* Navigation */}
            {sliderData.length > 1 && (
                <>
                    <button
                        onClick={prevSlide}
                        className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/20 hover:bg-white/40 text-white rounded-full p-3 transition-all z-10"
                    >
                        <FaChevronLeft size={24} />
                    </button>
                    <button
                        onClick={nextSlide}
                        className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/20 hover:bg-white/40 text-white rounded-full p-3 transition-all z-10"
                    >
                        <FaChevronRight size={24} />
                    </button>

                    {/* Dots */}
                    <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
                        {sliderData.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => setCurrentSlide(index)}
                                className={`w-3 h-3 rounded-full transition-all ${index === currentSlide ? 'bg-white scale-125' : 'bg-white/50'
                                    }`}
                            />
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default Slider;